// extracted by mini-css-extract-plugin
export var avatarContainer = "_8y-0";
export var avatarTypingWave = "_8y-i";
export var gray = "_8y-f";
export var green = "_8y-c";
export var icon = "_8y-9";
export var image = "_8y-1";
export var lg = "_8y-6";
export var md = "_8y-5";
export var presenceDot = "_8y-b";
export var red = "_8y-d";
export var sm = "_8y-4";
export var status = "_8y-a";
export var typingDot = "_8y-h";
export var typingPill = "_8y-g";
export var xl = "_8y-7";
export var xs = "_8y-3";
export var xxl = "_8y-8";
export var xxs = "_8y-2";
export var yellow = "_8y-e";